import PropTypes from "prop-types";
import React, {useEffect, useRef, useState} from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {withStyles} from "@material-ui/core";

import Tabs, {TabPane} from "rc-tabs";
import TabContent from "rc-tabs/lib/TabContent";
import TabBar from "rc-tabs/lib/TabBar";

import {main as styles} from "./styles";
import {Logo} from "../../../components";
import Canvas from "../../../components/canvas/Pixi";
import "rc-tabs/assets/index.css";
import {version} from "../../../config";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import classNames from "classnames";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const Main = ({classes, poi}) => {

	const img = poi.images
		? poi.images.split(",").map(f => `./data/images/${f}`)
		: [];
	const axonos = poi.axono
		? poi.axono.split(",").map(f => `./data/axono/${f}`)
		: [];
	const images = img.concat(axonos).map(img => ({
		original: img,
	}));

	if (!version.office) {
		poi.axono = [];
	}

	if (
		[
			"12-01",
			"12-02",
			"12-04",
			"12-05",
			"12-06",
			"902A",
			"1106A",
			"1201A",
			"1203",
			"1204",
		].indexOf(poi.lot) > -1
	) {
		poi.axono = ["data/axono/" + poi.lot + ".png"];
	}
	if (poi.visit360 && poi.visit360.length > 0) {
		poi.axono.push(poi.visit360);
	}

	if (poi.axono && poi.axono.length === 0) {
		poi.axono = null;
	}
	return (
		<main
			className={`${classes.mainWrapper} ${version.office &&
			classes.poiGallery}`}
		>
			{version.office ? (
				<ImageGallery
					items={images}
					showThumbnails={false}
					showFullscreenButton={false}
					showPlayButton={false}
				/>
			) : (
				<div className={classes.tabs}>
					{!poi.axono || (poi.axono.length > 0 && poi.axono[0] === "") ? (
						<div>
							<Canvas
								helperChooser="lci"
								poi={poi.lot}
								classes={{
									canvasPOI: classes.canvasFullHeight,
								}}
							/>
							<Logo/>
						</div>
					) : (
						<Tabs
							defaultActiveKey="1"
							tabBarPosition="bottom"
							renderTabBar={() => <TabBar className={classes.appBar}/>}
							renderTabContent={() => <TabContent/>}
							className={classes.tabs}
						>
							<TabPane tab="Situation" key="1">
								<Canvas
									helperChooser="lci"
									poi={poi.lot}
									className={classes.canvas}
								/>
								<Logo/>
							</TabPane>
							{poi.axono.map((axono, index) =>
								axono.match(/\.(jpg|jpeg|png)/iu) ? (
									<TabPane
										className={classes.tab}
										tab="AXONOMETRIE"
										key={index + 2}
									>
										<img
											title={`AXONOMETRIE ${index + 1}`}
											className={classes.iframe}
											src={axono}
											frameBorder="0"
										/>
									</TabPane>
								) : (
									<TabPane className={classes.tab} tab="3D" key={index + 2}>
										<iframe
											title="3D"
											className={classes.iframe}
											src={axono}
											frameBorder="0"
										/>
									</TabPane>
								),
							)}
						</Tabs>
					)}
				</div>
			)}
		</main>
	);
};

const mapStateToProps = state => ({
	pois: state.pois,
	medias: state.carousel[state.helpers.building],
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

Main.propTypes = {
	classes: PropTypes.object.isRequired,
	poi: PropTypes.object.isRequired,
};

export default withRouter(
	withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Main)),
);
